<ng-template [ngIf]="worklistItem.scannedDocuments?.length > 0">
  <ul class="clickable-link-list">
    <li
      *ngFor="
        let scannedDoc of worklistItem.scannedDocuments;
        let docIndex = index
      "
    >
      <span (click)="openFile(scannedDoc.name)">
        {{ getFileName(scannedDoc, docIndex) }}
      </span>
    </li>
  </ul>
</ng-template>
<div
  appFileUploadDragDrop
  (fileDropped)="onFileDropped($event)"
  *ngIf="editable"
  id="upload-section"
>
  <app-file-upload-display
    *ngFor="let fileInfo of fileUploadInfoList; index as ind"
    [fileInfo]="fileInfo"
    (removeFile)="cancelUpload($event)"
  ></app-file-upload-display>
  <div id="upload-action-container">
    <input
      type="file"
      class="file-input d-none"
      (change)="onFileSelected($event)"
      #fileUpload
      multiple
      [accept]="ScanDocsComponent.acceptedFileExtensionsStr"
    />
    <button
      mat-button
      mat-stroked-button
      type="button"
      class="upload-btn my-3"
      (click)="fileUpload.click()"
      id="file-upload-btn"
    >
      <fa-icon [icon]="faPaperclip"></fa-icon>
      Upload scanned documents
    </button>
  </div>
  <div>
    Successful uploads may take a few minutes to appear under Scanned Documents.
  </div>
</div>
